import { SlingoLang } from "@lib/titan2-slingo/dist/game/view/abstract/lang/SlingoLang";
import { AbstractControlPanelProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractControlPanelProperties";
import { FontStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/FontStyle";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { ButtonProperties } from "@lib/titan2/dist/game/control/properties/ButtonProperties";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { ToggleButtonProperties } from "@lib/titan2/dist/game/control/properties/ToggleButtonProperties";
import { Dictionary } from "@lib/titan2/dist/util/collection/Dictionary";
import { GameFontStyle } from "../style/GameFontStyle";
import { GameStyle } from "../style/GameStyle";
/**
 * ControlPanelProperties.ts
 */
export class ControlPanelProperties extends AbstractControlPanelProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.logoProperties.equals(other.logoProperties) &&
            this.playFeatureButtonProperties.equals(other.playFeatureButtonProperties) &&
            this.spinsProperties.equals(other.spinsProperties) &&
            this.spinsSlotsProperties.equals(other.spinsSlotsProperties) &&
            this.cashWinProperties.equals(other.cashWinProperties) &&
            this.xCashProperties.equals(other.xCashProperties) &&
            this.playFeatureButtonIconProperties.getKeys().every(key => other.playFeatureButtonIconProperties.getValue(key) === this.playFeatureButtonIconProperties.getValue(key));
    }
    setDefaultValues() {
        super.setDefaultValues();
        this.logoProperties = new SpriteProperties(GameStyle.LOGO, GameStyle.MODULE);
        this.collectButtonProperties = new ToggleButtonProperties(GameStyle.COLLECT_BUTTON, GameStyle.MODULE);
        this.collectButtonProperties.textFieldProperties = new TextFieldProperties(FontStyle.COLLECT_BUTTON, null, SlingoLang.COLLECT_BUTTON, ControlConstants.CENTER, ControlConstants.CENTER);
        this.collectButtonValueTextFieldProperties = new TextFieldProperties(GameFontStyle.COLLECT_BUTTON_LARGE_TEXT, null, null, ControlConstants.CENTER, ControlConstants.CENTER);
        this.collectIcons = {
            5: new SpriteProperties("5_slingos_icon", "Game"),
            6: new SpriteProperties("6_slingos_icon", "Game"),
            7: new SpriteProperties("7_slingos_icon", "Game"),
            8: new SpriteProperties("8_slingos_icon", "Game"),
            9: new SpriteProperties("9_slingos_icon", "Game"),
            10: new SpriteProperties("10_slingos_icon", "Game")
        };
        this.endGameButtonProperties = new ButtonProperties(GameStyle.END_GAME_BUTTON, GameStyle.MODULE);
        this.endGameButtonProperties.textFieldProperties = new TextFieldProperties(FontStyle.END_GAME_BUTTON, null, SlingoLang.END_GAME_BUTTON, ControlConstants.CENTER, ControlConstants.CENTER);
        this.playFeatureButtonProperties = new ToggleButtonProperties(GameStyle.COLLECT_BUTTON, GameStyle.MODULE);
        this.playFeatureButtonProperties.textFieldProperties = new TextFieldProperties(GameFontStyle.COLLECT_BUTTON, null, SlingoLang.COLLECT_BUTTON, ControlConstants.CENTER, ControlConstants.CENTER);
        this.playFeatureButtonIconProperties = new Dictionary();
    }
}
//# sourceMappingURL=ControlPanelProperties.js.map